import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  planzone: Boundaries["retrieveProjectReportTemplate"]["request"],
): State {
  const index = state.findIndex((res) => res.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          planzone,
          reportTemplates: [],
          request: setRequestStateToPending(),
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          planzone,
          reportTemplates: [],
          request: setRequestStateToPending(),
        },
      ];
}

function handleSuccess(
  state: State,
  {
    planzone,
    reportTemplates,
  }: Boundaries["retrieveProjectReportTemplate"]["success"],
): State {
  const index = state.findIndex((res) => res.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          planzone,
          reportTemplates,
          request: setRequestStateToSuccess(),
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          planzone,
          reportTemplates,
          request: setRequestStateToSuccess(),
        },
      ];
}

function handleFailure(
  state: State,
  planzone: Boundaries["retrieveProjectReportTemplate"]["failure"],
): State {
  const index = state.findIndex((res) => res.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          request: setRequestStateToFailure(),
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          planzone,
          reportTemplates: [],
          request: setRequestStateToFailure(),
        },
      ];
}

function handleEditPlanzoneReportTemplate(
  state: State,
  {
    planzone,
    reportTemplates,
  }: Boundaries["editProjectReportTemplate"]["success"],
): State {
  const index = state.findIndex((res) => res.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], reportTemplates },
        ...state.slice(index + 1),
      ]
    : state;
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveProjectReportTemplateRequested]: handleRequest,
    [events.retrieveProjectReportTemplateSucceeded]: handleSuccess,
    [events.retrieveProjectReportTemplateFailed]: handleFailure,
    [events.editProjectReportTemplateSucceeded]:
      handleEditPlanzoneReportTemplate,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
